(function () {
console.log("Parent theme.js loaded.");

})();
//# sourceMappingURL=theme.js.map
